module.exports = __webpack_public_path__ + "static/media/close.2bd509ca.svg";